<template>
  <div style="margin: 20px">
    <div v-if="!isView">
      <div style="display: flex; align-items: center">
        <p class="font-bold mt-3 text-lg mb-3" style="margin-left: 10px">
          Advice List
        </p>
        <div
          style="
            flex: 1;
            width: 100%;
            display: flex;
            flex-direction: row-reverse;
          "
        >
          <div>
            <el-input
              v-model="key_word"
              placeholder="Please input key word"
              @input="fetchData"
            ></el-input>
          </div>
        </div>
      </div>

      <div
        class="bg-white py-3 px-4 mt-3"
        style="margin: 12px 0px 0; border-radius: 5px"
      >
        <p class="text-sm">
          We are continuously updating insights and advice here for you
          reference.
        </p>
      </div>
      <div v-if="loading" style="text-align: center; padding: 40px">
        <i class="el-icon-loading" style="font-size: 24px"></i>
        <p>Loading...</p>
      </div>
      <div v-else-if="error" style="text-align: center; padding: 40px; color: #f56c6c">
        <p>⚠️ Unable to load posts</p>
        <p style="font-size: 12px; color: #999">{{ error }}</p>
        <el-button type="primary" size="small" @click="fetchData" style="margin-top: 10px">Retry</el-button>
      </div>
      <div v-else>
        <activity-advice
          v-for="(item, index) in dataList"
          :key="getPostId(item)"
          :info="item"
          :index="index"
          @view="viewAdvice(item)"
        />
        <div v-if="dataList.length === 0" style="text-align: center; padding: 40px; color: #999">
          <p>No posts available</p>
        </div>
      </div>
    </div>
    <div class="bg-white p-8" v-else>
      <div v-if="loadingPost" style="text-align: center; padding: 40px">
        <i class="el-icon-loading" style="font-size: 24px"></i>
        <p>Loading...</p>
      </div>
      <div v-else-if="postError" style="text-align: center; padding: 40px; color: #f56c6c">
        <p>⚠️ Unable to load post</p>
        <p style="font-size: 12px; color: #999">{{ postError }}</p>
        <el-button type="primary" size="small" @click="isView = false" style="margin-top: 10px">Go Back</el-button>
      </div>
      <div v-else>
        <div class="w-full flex justify-center">
          <div class="flex items-center" style="width: 800px">
            <i
              class="el-icon-arrow-left font-bold text-xl cursor-pointer"
              style="color: #999999"
              @click="isView = false"
            />
            <p class="text-xl ml-4 font-bold" style="color: #ff8e3b">
              {{ adviceInfo.title }}
            </p>
          </div>
        </div>
        <div class="w-full flex justify-center" style="margin-top: 25px">
          <div class="flex items-center" style="width: 800px">
            <span v-if="adviceInfo.collection_name" class="common-tag" style="margin-right: 15px">
              {{ adviceInfo.collection_name }}
            </span>
            <span class="text-sm" style="color: #999">
              Author: {{ adviceInfo.user_name || 'Unknown' }}
            </span>
          </div>
        </div>
        <div class="flex justify-center">
          <div
            class="mt-8 leading-6 rich-text"
            style="color: #666666; max-width: 800px; width: 100%; padding-bottom: 60px"
          >
            <!-- Render answers stacked vertically -->
            <div
              v-for="(answer, index) in adviceInfo.answers"
              :key="index"
              class="blog-post-answer"
              :style="{ marginTop: index === 0 ? '0' : '50px', marginBottom: '0' }"
            >
              <!-- Text content -->
              <div
                v-if="answer.content_type === 'text' && answer.content"
                class="markdown-content"
                v-html="renderMarkdown(answer.content)"
              ></div>
              
              <!-- Images -->
              <div
                v-if="answer.content_type === 'image' && answer.fileList && answer.fileList.length > 0"
                class="blog-images"
              >
                <div
                  v-for="(imageItem, imgIndex) in answer.fileList"
                  :key="imgIndex"
                  class="blog-image-container"
                  style="margin-bottom: 20px"
                >
                  <img
                    :src="getImageUrl(imageItem)"
                    :alt="getImageAlt(imageItem, imgIndex)"
                    class="blog-image"
                    style="max-width: 100%; height: auto; border-radius: 4px"
                  />
                </div>
              </div>
              
              <!-- Text with images (combined) -->
              <template v-if="answer.content_type === 'text' && answer.fileList && answer.fileList.length > 0">
                <div
                  v-for="(imageItem, imgIndex) in answer.fileList"
                  :key="'img-' + imgIndex"
                  class="blog-image-container"
                  style="margin-top: 20px; margin-bottom: 20px"
                >
                  <img
                    :src="getImageUrl(imageItem)"
                    :alt="getImageAlt(imageItem, imgIndex)"
                    class="blog-image"
                    style="max-width: 100%; height: auto; border-radius: 4px"
                  />
                </div>
              </template>
            </div>
            <div v-if="!adviceInfo.answers || adviceInfo.answers.length === 0" style="color: #999; padding: 20px">
              <p>No content available</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPostsInSpecificCollectionGroups, viewPostInGuestMode } from "../../api/eae";
import ActivityAdvice from "../../components/ActivityAdvice.vue";
import "../../assets/common/common.css";

export default {
  components: { ActivityAdvice },
  name: "index",
  data() {
    return {
      dataList: [],
      adviceInfo: {
        id: "",
        title: "",
        content: "",
        answers: [],
        collection_name: "",
        user_name: "",
      },
      showAdviceDialog: false,
      isView: false,
      key_word: '',
      loading: false,
      error: null,
      loadingPost: false,
      postError: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    getPostId(post) {
      if (!post._id) return '';
      if (typeof post._id === 'string') {
        return post._id;
      }
      if (typeof post._id === 'object') {
        return post._id.$id || post._id.$oid || post._id.toString() || '';
      }
      return String(post._id);
    },
    fetchData() {
      this.loading = true;
      this.error = null;
      
      // Collection groups parameter as specified
      const collection_groups = {
        '692cf13f94c784812a8b458c': { '$exists': true }
      };
      
      getPostsInSpecificCollectionGroups(collection_groups)
        .then((res) => {
          this.loading = false;
          if (res.data && res.data.code === 0 && res.data.data) {
            let posts = res.data.data;
            
            // Filter by keyword if provided
            if (this.key_word && this.key_word.trim()) {
              const keyword = this.key_word.toLowerCase().trim();
              posts = posts.filter(post => {
                const title = (post.title || '').toLowerCase();
                const content = this.getPreviewText(post).toLowerCase();
                return title.includes(keyword) || content.includes(keyword);
              });
            }
            
            this.dataList = posts;
          } else {
            this.dataList = [];
            this.error = res.data?.msg || 'No data returned';
          }
        })
        .catch((err) => {
          this.loading = false;
          this.error = err.message || 'Failed to load posts';
          console.error('Failed to load posts:', err);
        });
    },
    getPreviewText(post) {
      if (post.first_text_answer && post.first_text_answer.content) {
        const content = post.first_text_answer.content.trim();
        // Remove markdown syntax for preview
        let cleanContent = content
          .replace(/^#+\s+/gm, '')
          .replace(/\*\*([^*]+)\*\*/g, '$1')
          .replace(/__([^_]+)__/g, '$1')
          .replace(/\*([^*]+)\*/g, '$1')
          .replace(/_([^_]+)_/g, '$1')
          .replace(/\[([^\]]+)\]\([^\)]+\)/g, '$1')
          .replace(/!\[([^\]]*)\]\([^\)]+\)/g, '')
          .replace(/```[\s\S]*?```/g, '')
          .replace(/`([^`]+)`/g, '$1')
          .replace(/^[\s]*[-*+]\s+/gm, '')
          .replace(/^\d+\.\s+/gm, '')
          .replace(/^>\s+/gm, '')
          .replace(/\n+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
        return cleanContent.substring(0, 110);
      }
      return '';
    },
    async viewAdvice(post) {
      const postId = this.getPostId(post);
      if (!postId) {
        this.$message.error('Invalid post ID');
        return;
      }
      
      this.isView = true;
      this.loadingPost = true;
      this.postError = null;
      
      try {
        const res = await viewPostInGuestMode(postId);
        if (res.data && res.data.code === 0 && res.data.data) {
          const postData = res.data.data;
          this.adviceInfo = {
            id: postId,
            title: postData.title || 'Untitled',
            content: postData.description || '',
            answers: postData.answers || [],
            collection_name: postData.collection_name || '',
            user_name: postData.user_name || 'Unknown',
          };
        } else {
          this.postError = res.data?.msg || 'Post not found';
        }
      } catch (err) {
        this.postError = err.message || 'Failed to load post';
        console.error('Failed to load post:', err);
      } finally {
        this.loadingPost = false;
      }
    },
    renderMarkdown(content) {
      if (!content) return '';
      
      // Simple markdown to HTML conversion
      // Headers
      let html = content
        .replace(/^### (.*$)/gim, '<h3>$1</h3>')
        .replace(/^## (.*$)/gim, '<h2>$1</h2>')
        .replace(/^# (.*$)/gim, '<h1>$1</h1>')
        // Bold
        .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
        .replace(/__([^_]+)__/g, '<strong>$1</strong>')
        // Italic
        .replace(/\*([^*]+)\*/g, '<em>$1</em>')
        .replace(/_([^_]+)_/g, '<em>$1</em>')
        // Links
        .replace(/\[([^\]]+)\]\(([^\)]+)\)/g, '<a href="$2" target="_blank">$1</a>')
        // Code blocks
        .replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
        // Inline code
        .replace(/`([^`]+)`/g, '<code>$1</code>')
        // Line breaks
        .replace(/\n/g, '<br>');
      
      return html;
    },
    getImageUrl(imageItem) {
      if (typeof imageItem === 'string') {
        return imageItem;
      }
      return imageItem.url || imageItem.src || imageItem.data?.url || '';
    },
    getImageAlt(imageItem, index) {
      if (typeof imageItem === 'object') {
        return imageItem.name || imageItem.alt || `Blog image ${index + 1}`;
      }
      return `Blog image ${index + 1}`;
    },
  },
};
</script>

<style lang="less">
.rich-text {
  // Markdown headings - different from main title
  h1 {
    font-family: "PT Sans", "SF UI Display", ".PingFang SC", "PingFang SC",
      "Neue Haas Grotesk Text Pro", "Arial Nova", "Segoe UI", "Microsoft YaHei",
      "Microsoft JhengHei", "Helvetica Neue", "Source Han Sans SC",
      "Noto Sans CJK SC", "Source Han Sans CN", "Noto Sans SC",
      "Source Han Sans TC", "Noto Sans CJK TC", "Hiragino Sans GB", sans-serif;
    text-rendering: optimizelegibility;
    font-size: 1.5rem;
    font-weight: 600;
    margin-top: 1.5em;
    margin-bottom: 0.75em;
    line-height: 1.5;
    color: #333333;
  }
  h2 {
    font-family: "PT Sans", "SF UI Display", ".PingFang SC", "PingFang SC",
      "Neue Haas Grotesk Text Pro", "Arial Nova", "Segoe UI", "Microsoft YaHei",
      "Microsoft JhengHei", "Helvetica Neue", "Source Han Sans SC",
      "Noto Sans CJK SC", "Source Han Sans CN", "Noto Sans SC",
      "Source Han Sans TC", "Noto Sans CJK TC", "Hiragino Sans GB", sans-serif;
    text-rendering: optimizelegibility;
    font-size: 1.25rem;
    font-weight: 600;
    margin-top: 1.25em;
    margin-bottom: 0.5em;
    line-height: 1.5;
    color: #333333;
  }
  h3,
  h4,
  h5,
  h6 {
    font-family: "PT Sans", "SF UI Display", ".PingFang SC", "PingFang SC",
      "Neue Haas Grotesk Text Pro", "Arial Nova", "Segoe UI", "Microsoft YaHei",
      "Microsoft JhengHei", "Helvetica Neue", "Source Han Sans SC",
      "Noto Sans CJK SC", "Source Han Sans CN", "Noto Sans SC",
      "Source Han Sans TC", "Noto Sans CJK TC", "Hiragino Sans GB", sans-serif;
    text-rendering: optimizelegibility;
    font-weight: 600;
    margin-top: 1em;
    margin-bottom: 0.5em;
    line-height: 1.5;
    color: #333333;
  }
  ul {
    list-style-type: disc;
    list-style-position: inside;
  }
  ol {
    list-style-type: decimal;
    list-style-position: inside;
  }
}

.blog-post-answer {
  // Add spacing at the top of each answer section
  padding-top: 0;
  
  // Ensure first element in answer has proper spacing
  > *:first-child {
    margin-top: 0;
  }
  
  // Add extra spacing when answer starts with a heading
  h1:first-child,
  h2:first-child,
  h3:first-child,
  h4:first-child,
  h5:first-child,
  h6:first-child {
    margin-top: 0;
    padding-top: 0;
  }
}
</style>
